import React from "react";
import NavMain from "../nav/main";
import Brand from "../brand/base";

var Header = function Header(_ref) {
  var activePath = _ref.activePath,
      pages = _ref.pages,
      title = _ref.title;
  console.log(pages, title);
  return React.createElement("header", {
    className: "masthead masthead--course"
  }, React.createElement(Brand, null), React.createElement("h1", {
    className: "masthead__brand brand"
  }, React.createElement("a", {
    className: "brand__course-name",
    href: "/"
  }, title)), React.createElement(NavMain, {
    pages: pages,
    activePath: activePath
  }));
};

Header.defaultProps = {
  siteTitle: "Course name"
};
export default Header;